import React from "react";
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import SsoRateForm from './components/SsoRateForm';
import { DESK_SSO_RATE_FORM } from 'src/constants/FormNames';
import { setItem, getItem } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, updateDeskSsoRate, searchDeskSso } from 'src/reducers/desk/deskSsoRates';

let DeskSsoRateForm = reduxForm({
  form: DESK_SSO_RATE_FORM,
  enableReinitialize: true
})(SsoRateForm);

const mapStateToProps = state => ({
  initialValues: getItem(REDUCER_NAME, state)
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(updateDeskSsoRate(data));
  },
  searchDeskSso: (year, month, rateType, employeeType) => {
    dispatch(searchDeskSso(year, month, rateType, employeeType));
  }
});

DeskSsoRateForm = connect(mapStateToProps, mapDispatchToProps)(DeskSsoRateForm);

const DeskSsoRates = ({ dispatch, currentMonthSsoRate, allYear }) => {
  dispatch(setItem(REDUCER_NAME, currentMonthSsoRate));
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-offset-2 col-sm-4">
          <h2>Update of social security contribution rate</h2>
          <p>
            <span className="text-danger">【warning】</span><br />
            You can change social security contribution rate.<br />
            This change will apply to all clients.
          </p>
          <DeskSsoRateForm allYear={allYear} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default connect()(DeskSsoRates);